module.exports = __webpack_public_path__ + "static/media/TrainingPriceListUpload.b3924e3c.mp4";